export default "__VITE_ASSET__554bb18f__"